import { RenderBlock } from '@rst/render-blocks/src/types'

type ThemeFontType = {
	theme?: {
		font?: RenderBlock.InitFont
	}
	isHeadFont?: boolean
}

export const getFontWeight =
	(weight: number) =>
	({ theme, isHeadFont }: ThemeFontType) => {
		const propName = isHeadFont ? 'weights_head' : 'weights_main'
		if (!theme?.font?.[propName]?.length) return weight
		const acceptableWeights = theme.font[propName]
		if (acceptableWeights.length === 1) return acceptableWeights[0]
		if (acceptableWeights.includes(weight)) return weight

		const diffs = acceptableWeights.map((acceptableWeight, index) => ({
			diff: Math.abs(acceptableWeight - weight),
			index,
		}))

		const result =
			acceptableWeights[diffs.sort((a, b) => a.diff - b.diff)[0].index]
		return result
	}
